import API from "../../helpers/network/http";
import {Application} from "../../utils/types";

export default class RoleRequestService {
    // Create a method to create a role request
    static async whitelistApply(payload: Partial<Application>) {
        // Call the register endpoint from the API
        const {data} = await API.post("/whitelist-applications", payload);

        // Return the response
        return data.data;
    }

    // Method to get a user's role requests
    static async getWhitelistApplication(): Promise<Application> {
        // Call the login endpoint from the API
        const {data} = await API.get("/whitelist-applications/status");

        // Return the response
        return data.data;
    }

    // Create director application
    static async directorApply(payload: Partial<Application>) {
        try {
            // Call the register endpoint from the API
            const {data} = await API.post("/director-applications", payload);

            // Return the response
            return data.data;
        } catch (error: any) {
            // If server error, throw error
            throw new Error(error.response.data.message || error.message);
        }
    }

    // Method to get director application
    static async getDirectorApplication(): Promise<Application> {
        try {
            // Call the login endpoint from the API
            const {data} = await API.get("/director-applications/status");

            // Return the response
            return data.data;
        } catch (error: any) {
            // If server error, throw error
            throw new Error(error.response.data.message || error.message);
        }
    }

}